const regexpDevices = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/

export const isMobile = () => regexpDevices.test(navigator.userAgent)
